<template>
    <div class="unfinished-route" @click="onCruiseClick()">
        <div class="unfinishContent-route">
            <div class="unfinished-bg"></div>
            <div class="unfinishRoute-content">
                <div class="unfinishRoute-img"><img :src="lastCruise.titleImage"></div>
                <div class="unfinishRoute-txt">
                    <div class="unfinishRoute-title">您有未完成航线:</div>
                    <div class="unfinishRoute-name">
                        <span class="unfinishDate">{{lastCruise.sailDateStr}}</span>
                        <span class="unfinishCruiseName">{{lastCruise.cruiseName}}</span></div>
                    <div class="unfinishRoute-book"><a class="external">点击继续预订</a></div>
                </div>
                <div class="unfinishRoute-downArrow"><img src="https://resource.rcclchina.com.cn/homePage/mobile/unfinishImgDown.png"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HomeLastCruise",
    props: {
        lastCruise: {
            type: Object
        }
    },
    methods: {
        onCruiseClick () {
            try {
                if (window.gio) {
                    window.gio('track', 'UnfinishOrder')
                }
            } catch (error) {
                console.error(error)
            }
            this.$router.push({ name: 'CruiseDetail'
                , query: { shipCode: this.lastCruise.shipCode, sailDate: this.lastCruise.sailDate } })
        }
    }
}
</script>

<style lang="less" scoped>
.unfinished-route {
    width: 100%;
    position: fixed;
    height: 67px;
    bottom: 55px;
    padding: 0 10px;
    z-index: 22221;
    .unfinishContent-route {
        width: 100%;
        height: 100%;
        position: relative;
        .unfinished-bg {
            width: 100%;
            height: 100%;
            position: absolute;
            background: #000;
            opacity: .75;
            top: 0;
            z-index: 1;
            border-radius: 10px;
        }
        .unfinishRoute-content {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            z-index: 2;
            padding: 5px;
            .unfinishRoute-img {
                width: 57px;
                height: 57px;
                overflow: hidden;
                img {
                    width: 57px;
                }
            }
            .unfinishRoute-txt {
                width: 230px;
                height: 57px;
                overflow: hidden;
                padding: 0 5px;
                color: #fff;
                font-size: 12px;
                a {
                    color: #fff;
                }
            }
            .unfinishRoute-downArrow {
                width: 30px;
                height: 37px;
                overflow: hidden;
                img {
                    width: 30px;
                }
            }
        }
    }
}

.unfinishRoute-content .unfinishRoute-img, .unfinishRoute-content .unfinishRoute-txt, .unfinishRoute-content .unfinishRoute-downArrow {
    display: inline-block;
    vertical-align: middle;
}
</style>